import { render, staticRenderFns } from "./AboutActivity.vue.html?vue&type=template&id=f2563436&scoped=true&"
import script from "./AboutActivity.component.js?vue&type=script&lang=vueJs&"
export * from "./AboutActivity.component.js?vue&type=script&lang=vueJs&"
import style0 from "./AboutActivity.scoped.scss?vue&type=style&index=0&id=f2563436&prod&lang=vueScss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f2563436",
  null
  
)

export default component.exports